// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fast_track_aggregator-3FCgo";
export { _1 as "__esModule", _2 as "fast_track_aggregator" }
export default { "__esModule": _1, "fast_track_aggregator": _2 }
